import { Composition } from 'remotion';

// Components
import { EmployeeYearInReview } from '@/components/EmployeeYearInReview';

// Types & schemas
import { employeeYearInReviewSchema } from '@/schemas';

// Mocks
import { mockEmployeeYearInReview } from '@/mocks';

// Constants
import { VIDEO_CONFIG, COMPOSITIONS } from '@/constants';

// Utils
import { calculateEmployeeYearInReviewMetadata } from '@/utils';

export const RemotionRoot = () => {
  return (
    <Composition
      id={COMPOSITIONS.EMPLOYEE_YEAR_IN_REVIEW}
      component={EmployeeYearInReview}
      fps={VIDEO_CONFIG.fps}
      width={VIDEO_CONFIG.width}
      height={VIDEO_CONFIG.height}
      schema={employeeYearInReviewSchema}
      defaultProps={mockEmployeeYearInReview}
      calculateMetadata={calculateEmployeeYearInReviewMetadata}
    />
  );
};
